import * as React from 'react';
import classNames from 'classnames';
import {getBooleanVariants} from '../../utilities';

type DivProps = JSX.IntrinsicElements['div'];

export interface GridProps extends DivProps {
  bleed?: boolean;
  layoutMode?: boolean;
  equalHeight?: boolean;
  verticallyCentered?: boolean;
}

const BASE_CLASS = 'grid';

export function Grid({
  bleed = false,
  layoutMode = false,
  equalHeight = false,
  verticallyCentered = false,
  className = '',
  ...restProps
}: GridProps) {
  return (
    <div
      {...restProps}
      className={classNames(
        className,
        BASE_CLASS,
        getBooleanVariants(BASE_CLASS, {
          bleed,
          layoutMode,
          equalHeight,
          verticallyCentered,
        }),
      )}
    />
  );
}

export default Grid;
